/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Wang Chao
 * @date  2021/5/12 17:39
 * @des
 */
/**
 * Remove an item from an array
 */
export function remove (arr, item) {
  if (arr.length) {
    const index = arr.indexOf(item)
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Add an item to an array
 */
export function add (arr, item) {
  arr.push(item)
}

export function exist (arr, item) {
  return arr.indexOf(item) > -1
}

export function indexOf (arr, item) {
  return arr.indexOf(item)
}

export function unique (arr) {
  let newArr = []
  for (let i = 0; i < arr.length; i++) {
    if (!exist(newArr, arr[i])) {
      newArr.push(arr[i])
    }
  }
  return newArr
}

export function exchangeArrItem (arr, index1, index2) {
  arr.splice(index2, 1, ...arr.splice(index1, 1, arr[index2]))
}



// WEBPACK FOOTER //
// ./src/base/util/arrayutil.js